<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Existencia</h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Cantidad</th>
          <th scope="col">Precio</th>
          <th scope="col">CantidadTotal</th>
          <th scope="col">PrecioPromedio</th>
          <th scope="col">FechaReg</th>
          <th scope="col">Tipo</th>
          <th scope="col">ElemEmprFechaReg</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="existencia in datosPaginados" :key="existencia.idExistencia">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(existencia.idExistencia)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(existencia.idExistencia)" title="Editar">edit_square</i></td>
          <td>{{existencia.cantidad}}</td>
          <td>{{existencia.precio}}</td>
          <td>{{existencia.cantidadTotal}}</td>
          <td>{{existencia.precioPromedio}}</td>
          <td>{{getFormattedDate(existencia.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{existencia.tipo}}</td>
          <td>{{getFormattedDate(existencia.elemEmprFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteExistencia(existencia.idExistencia)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idExistencia" class="form-label">IdExistencia</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idExistencia" name="idExistencia" v-model="datoExistencia.idExistencia" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Elem Empr -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idElemEmpr" class="form-label"> Elem Empr</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idElemEmpr" name="idElemEmpr" v-model="datoExistencia.idElemEmpr">
                      <option v-for="elemEmpr in elemEmprs" :value="elemEmpr.idElemEmpr" :key="elemEmpr.idElemEmpr">
                        {{ elemEmpr.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Elem Empr -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="cantidad" class="form-label">Cantidad</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="cantidad" name="cantidad" v-model="datoExistencia.cantidad" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="precio" class="form-label">Precio</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="precio" name="precio" v-model="datoExistencia.precio" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="cantidadTotal" class="form-label">CantidadTotal</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="cantidadTotal" name="cantidadTotal" v-model="datoExistencia.cantidadTotal" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="precioPromedio" class="form-label">PrecioPromedio</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="precioPromedio" name="precioPromedio" v-model="datoExistencia.precioPromedio" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="fechaReg" name="fechaReg" v-model="datoExistencia.fechaReg" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoExistencia.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarExistencia" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditExistencia" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      existencias : [],
      datoExistencia : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      elemEmprs: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchElemEmprs()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.existencias.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwexistencias/nombre/'+this.nombreBusqueda).then(response=>{
          this.existencias=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.existencias.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwexistencias').then(response=>{
      this.existencias=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.existencias.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idElemEmpr'
        ,'cantidad'
        ,'precio'
        ,'cantidadTotal'
        ,'precioPromedio'
        ,'tipo'
      ];
      const requiredFieldsText = [
        'idElemEmpr'
        ,'cantidad'
        ,'precio'
        ,'cantidadTotal'
        ,'precioPromedio'
        ,'tipo'
      ];
      return validarForm(this.datoExistencia, requiredFields, requiredFieldsText);
    },
    async guardarExistencia(){
      if(this.validarForm() === 1){
        try {
          await api.post('/existencias', this.datoExistencia)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Existencia creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditExistencia(){
      if(this.validarForm() === 1){
        try {
          await api.post('/existencias', this.datoExistencia)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Existencia creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoExistencia={}
      this.titulo   = 'Crear Existencia'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idExistencia){
      this.modalWindow = true
      if(idExistencia != null){    
           api.get('/vwexistencias/'+idExistencia).then(resp=>{
          this.datoExistencia = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Existencia'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idExistencia){
      if(idExistencia != null){
        this.$router.push('/existenciamd/'+idExistencia)
      }
    },
    async deleteExistencia (idExistencia) {
      try{
        await api.delete('/existencias/'+idExistencia)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchElemEmprs() {
      fetch('http://localhost:8080/api/v1/elememprs')
        .then(response => response.json())
        .then(data => {
          this.elemEmprs = data;
        })
        .catch(error => {
          console.error('Error fetching elemEmprs:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
